const supplier = {
  path: 'supplier/',
  name: 'Supplier',
  redirect: { name: 'SupplierOverview' },
  children: [
    // Auth
    {
      path: 'register',
      name: 'SupplierRegister',
      component: () => import('@/views/supplier/register'),
      meta: {
        title: 'supplier_register',
      },
    },
    {
      path: 'register/completed',
      name: 'SupplierRegisterCompleted',
      component: () => import('@/views/supplier/register/Completed'),
      meta: {
        title: 'supplier_register_completed',
      },
    },
    {
      path: 'overview',
      name: 'SupplierOverview',
      component: () => import('@/views/supplier'),
      meta: {
        title: 'supplier_overview',
      },
    },
    {
      path: 'exhibition-booth/:id',
      name: 'SupplierExhibitionBooth',
      component: () => import('@/views/supplier/ExhibitionBooth'),
      meta: {
        title: 'supplier_exhibition_booth',
      },
    },
    {
      path: 'company-info/:id',
      name: 'SupplierCompanyInfo',
      component: () => import('@/views/supplier/CompanyInfo'),
      meta: {
        title: 'supplier_company_info',
      },
    },
  ],
};

export default supplier;
